export const locale = {
  lang: 'sp',
  data: {
    BITSO: {
      AWESOME: 'Crear Impresionante 🙌',
      BITSO: 'Administración de criptoactivos en Bitso',
      BITSO_ACCOUNT_DETAILS: 'Detalles de la cuenta',
      BITSO_CRYPTO_ASSETS: 'Criptoactivos',
      BITSO_CRYPTO_QUOTES: 'Cotizaciones Cripto',
      BITSO_THE_PURCHASE_WAS_COMPLETED_SUCCESSFULLY: 'La compra se realizó correctamente.',
      BITSO_SUCCESS: 'Éxito',
      BITSO_ERROR: 'Error',
      BITSO_COMMUNICATION_ERROR: 'Error de comunicación',
      GET_BALANCE: 'Obtener Balance',
      GET_QUOTE: 'Obtener Cotización',
      CONFIRM_PURCHASE: 'Confirmar Compra',
      GET_CUSTOMER_INFORMATION: 'Obtener Información de Cliente'
    }
  }
}